/* Main Menu */
var $ = jQuery.noConflict();

$(function(){
    $(document).ready(function() {
        ////////////////////////////////////////////////
        // START - mobile nav toggle (made with vanilla JS " START -  mobile nav toggle JS")
		// $('.navbar-toggler').on('click', function() {
		// 	$('.navbar-bg').toggleClass('is-active');
		// 	$('.navbar').toggleClass('is-active');
		// 	// toggle aria expanded value
		// 	$(this).attr('aria-expanded', function(i, attr) {
		// 		return attr == 'true' ? 'false' : 'true'
		// 	});
		// });
        // END - mobile nav toggle
        ///////////////////////////////////////////////

        ///////////////////////////////////////////////////////
        // START - initiate animate on scroll
        $('a.smooth-anchor-scroll').on('click', function() {
            if ( $("body").hasClass("admin-bar") ) {
                var offset = ( $('#wpadminbar').outerHeight() + $('.header').outerHeight() ) * (-1);
            } else {
                var offset = $('.header').outerHeight() * (-1);
            }

            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top + offset
                    }, 1);
                    return false;
                }
            }
        });
        // END - initiate animate on scroll
        ///////////////////////////////////////////////////////
    });
});

"use strict";

////////////////////////////////////////////////
// START -  mobile nav toggle JS
var navbarToggler = document.querySelector('.navbar-toggler');
var navbarBg = document.querySelector( '.navbar-bg' );
var navBar = document.querySelector( '.navbar' );
var ariaExpanded = navbarToggler.getAttribute( 'aria-expanded' ); 

navbarToggler.addEventListener( 'click' , function() {

    navBar.classList.toggle( 'is-active' );

    if (ariaExpanded == 'true' ) {
        ariaExpanded = 'false'
    } else {
        ariaExpanded = 'true'
    }
    navbarToggler.setAttribute( 'aria-expanded' , ariaExpanded);
});
// END - mobile nav toggle JS
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - remove load class from body
$(window).on('load', function() {
    // When the page has loaded
    $('body').removeClass('page-loading');
});
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - init bootstrap tooltips
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})
// END - init bootstrap tooltips
///////////////////////////////////////////////



function handleToggleButtonClick(target) {
    const grid = document.querySelector('.team-archive-grid');
    const card = target.closest('.card--team');

    if (card && card.classList.contains('card--team-open')) {
        // If the card is already open, reset all cards
        resetAllCards(grid);
    } else {
        // Open the clicked card
        handleTextLinkClick(target);
    }
}

function handleCloseButtonClick(target) {
    const grid = document.querySelector('.team-archive-grid');

    if (grid) {
        // Reset all cards and info divs to default state
        resetAllCards(grid);
    }
}

function resetAllCards(grid) {
    // Remove active states from all cards
    const allCards = grid.querySelectorAll('.card--team');
    const allInfoCards = grid.querySelectorAll('.card-more-info');

    allCards.forEach(card => {
        card.classList.remove('card--team-open');
        const textLink = card.querySelector('.text-link__text');
        if (textLink) {
            textLink.textContent = 'More info';
        }
    });

    allInfoCards.forEach(infoCard => {
        infoCard.style.display = 'none';
        infoCard.classList.remove('card-more-info--active');
        infoCard.innerHTML = '';
    });
}

// Updated click handler for text-link and close-btn
document.addEventListener('click', function(event) {
    const grid = document.querySelector('.team-archive-grid');
    if (grid && grid.contains(event.target)) {
        const button = event.target.closest('.text-link');
        if (button) {
            handleToggleButtonClick(button);
        } else if (event.target.closest('.close-btn')) {
            handleCloseButtonClick(event.target);
        }
    }
});

function handleTextLinkClick(button) {
    const card = button.closest('.card--team');
    const buttonText = button.querySelector('.text-link__text');
    const grid = document.querySelector('.team-archive-grid');

    // Reset all cards to ensure only one is active
    resetAllCards(grid);

    if (buttonText.textContent === 'More info') {
        buttonText.textContent = 'Show less';
        card.classList.add('card--team-open');

        const currentArticle = card.closest('article');
        let nextInfoCard = currentArticle.nextElementSibling;

        // Find the corresponding .card-more-info
        while (nextInfoCard && !nextInfoCard.classList.contains('card-more-info')) {
            nextInfoCard = nextInfoCard.nextElementSibling;
        }

        if (nextInfoCard) {
            // Clone the current article content and show in .card-more-info
            const clonedArticle = currentArticle.cloneNode(true);
            nextInfoCard.innerHTML = '';
            nextInfoCard.appendChild(clonedArticle);
            nextInfoCard.classList.add('card-more-info--active');
            nextInfoCard.style.display = 'block';
        }
    }
}

// Initialize and bind events
document.addEventListener('DOMContentLoaded', function() {
    handleResize();
});

window.addEventListener('resize', handleResize);

function handleResize() {
    const grid = document.querySelector('.team-archive-grid');
    if (grid) {
        grid.querySelectorAll('.card-more-info').forEach(div => div.remove());

        const articles = grid.querySelectorAll('article');
        let insertAfterNth = 2; // Default position to insert div

        if (window.matchMedia('(min-width: 960px)').matches) {
            insertAfterNth = 3;
        }

        // Insert 'card-more-info' after every nth article
        for (let i = insertAfterNth - 1; i < articles.length; i += insertAfterNth) {
            const moreInfoDiv = document.createElement('div');
            moreInfoDiv.className = 'card-more-info';
            if (articles[i].nextSibling) {
                articles[i].parentNode.insertBefore(moreInfoDiv, articles[i].nextSibling);
            } else {
                articles[i].parentNode.appendChild(moreInfoDiv);
            }
        }

        // Ensure there is a 'card-more-info' at the end of the grid
        const lastChild = grid.lastElementChild;
        if (!lastChild.classList.contains('card-more-info')) {
            const moreInfoDiv = document.createElement('div');
            moreInfoDiv.className = 'card-more-info';
            grid.appendChild(moreInfoDiv);
        }
    }
}



// Initialize and bind events
document.addEventListener('DOMContentLoaded', function() {
    handleResize();
});

window.addEventListener('resize', handleResize);
